<template>
  <el-popover
    v-loading="loading"
    placement="right"
    @show="show"
    @after-enter="toggle"
    v-model="visible"
    trigger="click">
    <el-table ref="taxesTable" :data="taxesModel" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column width="150" property="name" :label="$t('taxes.name')"></el-table-column>
      <el-table-column width="100" property="rate" :label="$t('taxes.rate')"></el-table-column>
      <el-table-column width="300" property="number" :label="$t('taxes.taxesCode')"></el-table-column>
    </el-table>
    <div class="right">
        <el-button class="m-10" @click="visible=false">{{$t('common.Cancel')}}</el-button>
        <el-button type="primary" class="m-10" @click="apply">{{ $t('common.apply') }}</el-button>
    </div>
    <el-button slot="reference" type="text" class="m-0 p-0 fs-12">
      <span v-if="usedTaxes==null || usedTaxes.length==0"><i class="el-icon-circle-plus-outline"></i> taxes</span>
      <span v-else>{{usedTaxeNames}} <i class="el-icon-edit"></i></span>
    </el-button>
  </el-popover>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import salesUtils from '@/utils/sales-utils.js'

export default {
	name: 'TaxesPopover',
	props: {
    systemId : Number,
    usedTaxes : Array,
  },
	components : {

	},
	data() {
		return {
      taxesModel : [],
      visible : false,
      multipleTaxesSelection : [],
      loading : false,
		}
	},
	computed : {
    usedTaxeNames(){
      return salesUtils.getUsedTaxesNames(this.usedTaxes);
    },
    ...mapState('controlData',['taxes'])
  },
	methods : {
    show(){
      this.loading=true;
      this.taxesModel = [];
      this.multipleTaxesSelection = [];
      _.forEach(this.taxes, (t, i)=>{
        this.taxesModel.push(_.cloneDeep(t));
      })
      this.toggle();
    },
    toggle(){
      let toggles = [];
      _.forEach(this.taxesModel, (t,i)=>{
        let usedTax = _.find(this.usedTaxes, ut=>{return ut.id==t.id});
        if(usedTax)this.toggleSelection([this.taxesModel[i]]);
      })
      this.loading = false;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.taxesTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.taxesTable.clearSelection();
      }
    },
    handleSelectionChange(val){
      this.multipleTaxesSelection = val;
    },
    apply(){
      this.$emit('applyTaxes',this.multipleTaxesSelection);
      this.visible = false;
    },
    ...mapActions('controlData',['fetchTaxes'])

  },
  created(){
    this.fetchTaxes();
  }
}
</script>
<style lang="scss">
@import '../assets/scss/_variables';


</style>
